<template>
  <AppDialog
    title="Import list to bulk update members"
    class="members-update-dialog"
    append-to-body
    show
    @close="close"
  >
    <div
      v-if="isShowSeatCountWarning"
      style="align-items: center"
      class="seats-increase-warning-box dialog-warning blue"
    >
      <i class="d-flex hi hi-info-filled hi-12 text-blue" />

      <div>
        Changing member roles from Project viewers (free seat) to paid seats will increase your subscription invoice.
        <a
          class="learn-more-seats"
          href="https://support.hubstaff.com/per-seat-pricing/"
        >
          Learn more
        </a>
      </div>
    </div>
    <AppFileImport
      resource-type="members_update"
      template-event
      :file-types="fileTypes"
      :loading="loading"
      :mime-types="mimeTypes"
      :organization-id="organizationId"
      :file-params="fileParams"
      :auto-close="false"
      @upload-file="upload"
      @remove-file="remove"
      @is-loading="onIsLoading"
      @download-template="$emit('download-template')"
      @close="close"
      @import-success="onImportSuccess"
    />
  </AppDialog>
</template>
<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import { OrganizationsResource } from '~/resources';
import * as types from '~/stores/MembersStore/types';
import { removeFile, uploadFile } from '~/utils/file_utils';

export default {
  name: 'MembersUpdateUploadFileDialog',
  components: {},
  props: {},
  computed: {
    ...mapState({
      fileParams: 'file_params',
      fileImportLoading: 'file_import_loading',
      enterprise: 'enterprise_plan',
      membersCount: 'members_count',
      seatsMembersCount: 'seats_members_count',
      organization: 'organization',
    }),
    ...mapGetters(['organizationId', 'mimeTypes', 'fileTypes', 'accountProvisioningVisible', 'hasFeature']),
    billingOrganizationUrl() {
      return OrganizationsResource.billingLink({ id: this.organizationId });
    },
    loading() {
      return !!this.fileImportLoading;
    },
    isShowSeatCountWarning() {
      return this.organization.show_per_seat_ui && this.membersCount > this.seatsMembersCount;
    },
  },
  methods: {
    ...mapMutations({
      setLoading: types.SET_UPLOAD_LOADING,
    }),
    close() {
      removeFile(this, types);
      this.$emit('close');
    },
    upload(file) {
      this.setLoading(true);
      uploadFile(this, file, types).catch((e) => {
        this.setLoading(false);
        this.$appMessage(e.message);
      });
    },
    remove() {
      this.setLoading(true);
      removeFile(this, types);
      this.setLoading(false);
    },
    onIsLoading(val) {
      this.setLoading(val);
    },
    onImportSuccess(response) {
      removeFile(this, types);
      this.$emit('file-uploaded', response);
    },
  },
};
</script>
